import React, { useEffect, useRef, useState } from "react";
import { useFormikContext } from "formik";
import { KTSVG, toAbsoluteUrl } from "../../../../../_metronic/helpers";

export default function ImageField() {
  const { setFieldValue, values } = useFormikContext();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [preview, setPreview] = useState<string | null>(null);

  useEffect(() => {
    if (!values.profile_picture) {
      setPreview(null);
      return;
    }

    // Si ya es una URL (editar)
    if (typeof values.profile_picture === 'string') {
      setPreview(values.profile_picture);
      return;
    }

    // Si es File (create o change)
    const objectUrl = URL.createObjectURL(values.profile_picture);
    setPreview(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [values.profile_picture]);

  // Cuando el usuario hace click
  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
      inputRef.current.click();
    }
  };

  // Cuando selecciona imagen
  const handleFile = (file) => {
    if (!file) return;

    if (!file.type.startsWith("image/")) return;

    setFieldValue("profile_picture", file);
  };

  const removeImage = () => {
    setPreview(null);
    setFieldValue("profile_picture", null);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  // Drag & drop
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleFile(file);
  };

  return (<>
      <div className={`tap-add-experience-2-upload-area tap-flex-center ${preview ? 'd-none' : 'd-flex'}`} onClick={handleClick}>
        <div className="tap-flex-center flex-column">
          <div className="img-upload">
            <KTSVG className="img-upload" path={toAbsoluteUrl('/media/svg/nobilis/teams_and_partner/upload_icon.svg')} />
          </div>
          <div className="description">Drag your photo here or upload</div>
          <div className="btn_upload">UPLOAD IMAGE</div>
        </div>
      </div>
      <div className={`tap-add-experience-2-upload-area ${preview ? 'd-flex' : 'd-none'}`}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
        style={{
          backgroundImage: preview ? `url(${preview})` : "none",
          backgroundSize: 'contain',
          backgroundPosition: 'left',
          border: 'none',
          backgroundColor: 'white',
        }}>
        {!preview && (
          <div className="upload-placeholder">
            {/* Click or drag an image here */}
          </div>
        )}
        <input type="file" ref={inputRef} style={{ display: "none" }} accept="image/*" onChange={(e) => handleFile(e.target.files?.[0])}/>
      </div>
      <div className={`tap-image-actions ${preview ? 'd-flex' : 'd-none'}`}>
        <div className="tap-image-actions__item" onClick={removeImage}>
          <div className="tap-image-actions__label">remove image</div>
        </div>
        <div className="tap-image-actions__item" onClick={handleClick}>
          <div className="tap-image-actions__label">change image</div>
        </div>
      </div>
    </>
  );
}
